export const GET_CMS_PAGES = 'GET_CMS_PAGES';
export const GET_CMS_PAGES_SUCCESS = 'GET_CMS_PAGES_SUCCESS';
export const GET_CMS_PAGES_FAIL = 'GET_CMS_PAGES_FAIL';
